import { useReducer, useEffect } from 'react'
import { useTheme, Tab, Tabs } from '@mui/material'
import {
    UniversalCookieCrumb,
    DataGridLayout,
    TabPanel,
} from '../../UniversalComponents'
import { useMinimizer } from '../../../context/MinimizeContext'
import { useAuth } from '../../../context/AuthenticationContext'
import Dealers from './Dealer'
import { DealerProfiles } from './DealerProfile'

const DealerIndex = () => {
    const reducer = (state, newState) => ({ ...state, ...newState })
    const { auth } = useAuth()
    const defaultState = {
        currentTab: 0,
        tabName: '',
    }

    const [state, setState] = useReducer(reducer, defaultState)

    const { currentTab, tabName } = state
    const tabs =
        auth && auth?.userProfile && auth?.userProfile?.superAdmin
            ? ['Dealer Profiles', 'Dealers']
            : ['Dealers']

    const isDealer =
        auth && auth?.userProfile && auth?.userProfile?.dealerProfile

    const setCurrentTab = (event: React.SyntheticEvent, newValue: number) =>
        setState({ currentTab: newValue, tabName: tabs[newValue] })

    const theme = useTheme()
    const { restoredData } = useMinimizer()

    useEffect(() => {
        if (
            restoredData?.id !== undefined &&
            restoredData?.tab === 'useradmin'
        ) {
            setState({ currentTab: 0 })
        }
        if (
            restoredData?.id !== undefined &&
            restoredData?.tab === 'usernotificationsubscription'
        ) {
            setState({ currentTab: 1 })
        }
    }, [restoredData])

    return (
        <DataGridLayout
            cookieCrumbs={<UniversalCookieCrumb customTitle={tabName} />}
            tabBar={
                <Tabs
                    value={currentTab}
                    onChange={setCurrentTab}
                    indicatorColor="secondary"
                    textColor="primary"
                    variant="scrollable"
                    aria-label="Osmosis"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                >
                    {isDealer ? (
                        <> </>
                    ) : (
                        tabs?.map((label, index) => (
                            <Tab key={index} label={label} />
                        ))
                    )}
                </Tabs>
            }
            dataGrid={
                <>
                    {isDealer ? (
                        <>
                            <DealerProfiles />
                        </>
                    ) : (
                        <>
                            <TabPanel
                                value={currentTab}
                                index={0}
                                dir={theme.direction}
                            >
                                <DealerProfiles />
                            </TabPanel>

                            {tabs.length === 2 && (
                                <TabPanel
                                    value={currentTab}
                                    index={1}
                                    dir={theme.direction}
                                >
                                    <Dealers />
                                </TabPanel>
                            )}
                        </>
                    )}
                </>
            }
        />
    )
}

export default DealerIndex
